import "./index.less";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";

// framework
import { logger, redux } from "./framework";
import App from "./App";

// application
function Root() {
  return (
    <Provider store={redux.getStore()}>
      <App />
    </Provider>
  );
}

if (
  process.env.NODE_ENV !== "development" &&
  typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === "object"
) {
  for (const prop in window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    if (prop === "renderers") {
      // this line will remove that one console error
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] = new Map();
    } else {
      // Replace all of its properties with a no-op function or a null value
      // depending on their types
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] =
        typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] === "function"
          ? () => {}
          : null;
    }
  }
}

logger.getLogger("init").info(process.env.NODE_ENV + "");
ReactDOM.render(<Root />, document.getElementById("root"));
